import { Pipe, PipeTransform } from '@angular/core';
import { DateUtils } from '@flipto/shared/src/lib/utils/common/time/date-utils';

@Pipe({
    name: 'isDateSame',
    standalone: false
})
export class IsDateSamePipe implements PipeTransform {
    constructor() {
    }

    transform(value: Date, date: Date, unit: any = 'day'): boolean {
        if (value) {
           return DateUtils.isSame(value, date, unit);
        }
        return false;
    }
}
